"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/button.ts
var _button = require('@ariakit/react-core/button/button');



exports.Button = _button.Button;
